import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ClubbieButton from "../../components/ClubbieButton/ClubbieButton";
import ClubbieInput from "../../components/ClubbieInput/ClubbieInput";
import {
  createTournament,
  selectTournament,
  updateSelectedTournament,
} from "../../redux/slices/tournamentSlice";
import { DASHBOARD_STACK } from "../../utils/screenNames";
import { tournamentWizardStepCompleted } from "../../utils/analytics";
import { WIZARD_STEP } from "../../utils/analyticsEvents";

const TournamentName = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [tournamentName, setTournamentName] = useState("");
  const [isCreating, setIsCreating] = useState(false);
  const selectedOrganisation = useSelector(
    (state) => state.organisation.selectedOrganisation
  );

  const handleNextClick = async () => {
    try {
      if (!tournamentName.trim()) {
        toast.error("Please enter a tournament name");
        return;
      }

      setIsCreating(true);

      const createResult = await dispatch(
        createTournament({
          name: tournamentName,
          organisationId: selectedOrganisation.id,
        })
      );

      if (createResult.meta.requestStatus === "rejected") {
        throw new Error(createResult.payload || "Failed to create tournament");
      }

      const newTournament = createResult.payload;

      dispatch(selectTournament(newTournament.id, { isSelected: true }));

      const updateResult = await dispatch(
        updateSelectedTournament({
          id: newTournament.id,
          updateData: {
            isSelected: true,
          },
        })
      );

      if (updateResult.meta.requestStatus === "rejected") {
        throw new Error(updateResult.payload || "Failed to update tournament");
      }

      tournamentWizardStepCompleted({
        stepName: WIZARD_STEP.TOURNAMENT_NAME,
        tournamentId: newTournament?.id,
      });
      toast.success(`Competition "${tournamentName}" created successfully!`);
      navigate(DASHBOARD_STACK.CREATE_TOURNAMENT.TOURNAMENT_LOGO);
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <h4 className="text-[#FEFCEB] mb-4 Fsize_20">Name Your Competition</h4>
      <div className="w-100" style={{ minWidth: "400px" }}>
        <ClubbieInput
          value={tournamentName}
          onChange={(e) => setTournamentName(e.target.value)}
          placeholder="Enter competition name..."
        />
      </div>
      <ClubbieButton
        className="clubbie-button mt-4"
        onClick={handleNextClick}
        disabled={!tournamentName.trim()}
        isLoading={isCreating}
      >
        Next
      </ClubbieButton>
    </div>
  );
};

export default TournamentName;
